import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ISelectorItem } from "../../common/selector/selector.component";
import { IEvent, MatchStatus } from "../../services/match.service";
import { StatsService } from "../../services/stats.service";

@Component({
  selector: "app-map-controls",
  templateUrl: "./map-controls.component.html",
  styleUrls: ["./map-controls.component.scss"],
})
export class MapControlsComponent implements OnInit {
  _events: IEvent[] = [];
  _teams: any = {};
  _live: boolean;
  @Input() get teams(): any {
    return this._teams;
  }
  set teams(teams: any) {
    this._teams = teams;
    this.refreshStats();
  }
  @Input() get events(): IEvent[] {
    return this._events;
  }
  set events(events: IEvent[]) {
    this._events = events;
    this.setQuarterSelector();
    this.refreshStats();
  }
  @Input() get live(): boolean {
    return this._live;
  }
  set live(live: boolean) {
    this._live = live;
    this.updateLiveMode();
    this.refreshStats();
  }
  @Output() changeQuarter = new EventEmitter();
  @Output() changeMapMode = new EventEmitter();
  quarterItems: ISelectorItem[];
  mapModeItems: ISelectorItem[];
  selectedMapMode = null;

  constructor(
    private statsService: StatsService,
    private translateService: TranslateService
  ) {
    this.mapModeItems = [
      {
        label: this.translateService.instant("Zone"),
        icon: "/assets/img/icons/positive-clear/viz-zone.svg",
        value: "zone",
        toggle: {
          label: this.translateService.instant("Leader"),
          value: "leader",
          onChange: this.onZoneToggleChange.bind(this),
        },
        disabled: this.live,
      },
      {
        label: this.translateService.instant("Grid"),
        icon: "/assets/img/icons/positive-clear/viz-grid.svg",
        value: "grid",
      },
      {
        label: this.live
          ? this.translateService.instant("Live")
          : this.translateService.instant("Shots"),
        icon: "/assets/img/icons/positive-clear/viz-raw.svg",
        value: "raw",
        // toggle: {
        //   label: this.translateService.instant('Area'),
        //   value: 'area',
        //   onChange: this.onRawToggleChange
        // }
      },
    ];
    this.selectedMapMode = this.mapModeItems[0];
  }

  ngOnInit() {
    if (this.events.length) {
      this.refreshStats();
    }
  }

  setQuarterSelector() {
    this.quarterItems = [
      {
        label: this.translateService.instant("MATCH"),
        sublabel: "",
        value: MatchStatus.Finished,
      },
      {
        label: this.translateService.instant("1st quarter"),
        sublabel: "",
        value: MatchStatus.Quarter1,
        disabled: this.live,
      },
      {
        label: this.translateService.instant("2nd quarter"),
        sublabel: "",
        value: MatchStatus.Quarter2,
        disabled: this.live,
      },
      {
        label: this.translateService.instant("3rd quarter"),
        sublabel: "",
        value: MatchStatus.Quarter3,
        disabled: this.live,
      },
      {
        label: this.translateService.instant("4th quarter"),
        sublabel: "",
        value: MatchStatus.Quarter4,
        disabled: this.live,
      },
    ];

    // Add Overtime in case of needing it
    const lastEvent = this.events.length
      ? this.events[this.events.length - 1]
      : null;
    if (lastEvent && lastEvent.quarter >= MatchStatus.Overtime) {
      const overtimeText = this.translateService.instant("Overtime");
      for (let i = 10; i <= lastEvent.quarter; i++) {
        const overtimeIndex = i - 10;
        this.quarterItems.push({
          label: `${overtimeText} ${i - 9}`,
          sublabel: "",
          value: MatchStatus.Overtime + overtimeIndex,
          disabled: this.live,
        });
      }
    }
  }

  refreshStats() {
    if (this._events.length && this.teams.home) {
      for (let i = 0; i < this.quarterItems.length; i++) {
        let quarterResult;
        if (i === 0) {
          quarterResult = this.statsService.calculateResult(
            this.events,
            this.teams,
            MatchStatus.Finished
          );
        } else {
          quarterResult = this.statsService.calculateResult(
            this.events,
            this.teams,
            this.quarterItems[i].value,
            false
          );
        }
        this.quarterItems[
          i
        ].sublabel = `${quarterResult.home} - ${quarterResult.visitor}`;
      }
    }
  }

  updateLiveMode() {
    this.mapModeItems[0].disabled = this.live;
    this.mapModeItems[1].disabled = this.live;
    this.mapModeItems[2].label = this.live
      ? this.translateService.instant("Live")
      : this.translateService.instant("Shots");

    if (this.live) {
      this.selectedMapMode = this.mapModeItems[2];
    }
    for (let i = 0; i < this.quarterItems.length; i++) {
      if (i) {
        this.quarterItems[i].disabled = this.live;
      }
    }
  }

  onQuarterChange(event) {
    this.changeQuarter.emit(event);
  }

  onMapModeChange(event) {
    this.changeMapMode.emit(event);
    for (let i = 0; i < this.quarterItems.length; i++) {
      if (i) {
        this.quarterItems[i].disabled = this.live;
      }
    }
  }

  onZoneToggleChange(event) {
    let map;
    if (event === true) {
      map = "zoneLeader";
    } else {
      map = "zone";
    }
    this.changeMapMode.emit(map);
  }

  onRawToggleChange(event) {
    console.log(event);
  }
}
